import { DOCUMENTS_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { useHasPermission } from '@Contexts/appContext';
import { type ApiDynamicExportDefinition } from '@Model';
import { Table } from '@synqo/frontend-component-library';
import { getDynamicExportCategoryLabel, getDynamicExportKeyLabel } from '@Constants/dynamicExportConstants';
import { useListApi } from '@Hooks/useListApi';
import { DynamicExportDefinitionRepository } from '@Repositories/Documents';

export function FrameListDynamicExportDefinitions() {
    const hasPermission = useHasPermission();

    const module = useListApi(DynamicExportDefinitionRepository, DOCUMENTS_API);

    return (
        <Table<ApiDynamicExportDefinition>
            name={'DynamicExportDefinitionsList'}
            columns={[
                {
                    name: 'category',
                    label: 'Kategorie',
                    renderCell: ({ cellData }) => getDynamicExportCategoryLabel(cellData as string),
                },
                {
                    name: 'key',
                    label: 'Art',
                    renderCell: ({ cellData }) => getDynamicExportKeyLabel(cellData as string),
                },
                {
                    name: 'label',
                    label: 'Bezeichnung',
                },
            ]}
            loader={module.loadPage}
            canCreate={hasPermission(Permission.DocumentsDynamicExportRunCreate)}
            useOnClickNavigation
            fullSize
        />
    );
}
